(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class RetronaMobileNav extends HTMLElement {
    connectedCallback() {
      if(this.controller)return;
      this.header=this.closest('header'); this.button=this.querySelector('button');
      this.controller=new AbortController(); const signal=this.controller.signal;
      this.button.hidden=false; this.header.classList.add('ret-mobile-ready');
      this.setOpen=(open)=>{this.header.classList.toggle('ret-menu-open',open);this.button.setAttribute('aria-expanded',String(open));this.button.setAttribute('aria-label',open?'Close shop menu':'Open shop menu');};
      this.button.addEventListener('click',()=>this.setOpen(this.button.getAttribute('aria-expanded')!=='true'),{signal});
      this.header.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.button.getAttribute('aria-expanded')==='true'){this.setOpen(false);this.button.focus();}},{signal});
      this.header.querySelector('nav').addEventListener('click',event=>{if(event.target.closest('a'))this.setOpen(false);},{signal});
      document.addEventListener('pointerdown',event=>{if(!this.header.contains(event.target))this.setOpen(false);},{signal});
      matchMedia('(min-width:750px)').addEventListener('change',()=>this.setOpen(false),{signal});
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  }
  if(!customElements.get('retrona-mobile-nav'))customElements.define('retrona-mobile-nav',RetronaMobileNav);


  class RetronaUrinalMenu extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.links = [...this.querySelectorAll('.ret-shop-header__submenu a')];
      if (!this.details || !this.summary) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.pinned = false;
      this.hoverOpened = false;
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      this.details.addEventListener('toggle', () => this.summary.setAttribute('aria-expanded', String(this.details.open)), { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
        if (!this.details.open) { this.details.open = true; this.hoverOpened = true; }
      }, { signal });
      this.addEventListener('pointerleave', () => {
        if (!this.pinned && !this.contains(document.activeElement)) this.close();
      }, { signal });
      this.summary.addEventListener('click', event => {
        event.preventDefault();
        if (this.details.open && this.hoverOpened && !this.pinned) {
          this.pinned = true; this.hoverOpened = false;
        } else if (this.details.open) {
          this.close();
        } else {
          this.details.open = true; this.pinned = true;
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault(); event.stopPropagation(); this.close(); this.summary.focus();
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          this.details.open = true; this.pinned = true;
          const current = this.links.indexOf(document.activeElement);
          const next = current < 0 ? (direction === 1 ? 0 : this.links.length - 1) : (current + direction + this.links.length) % this.links.length;
          this.links[next]?.focus();
        }
      }, { signal });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); }, { signal });
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, { signal });
    }
    close() { if (this.details) this.details.open = false; this.pinned = false; this.hoverOpened = false; }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  if (!customElements.get('retrona-urinal-menu')) customElements.define('retrona-urinal-menu', RetronaUrinalMenu);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
class RetronaUrinalFilters extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.selection = '';
    this.scope = this.closest('.shopify-section');
    this.gridContainer = this.scope?.querySelector('#ProductGridContainer');
    if (!this.gridContainer) return;
    this.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-reset')) this.selection = '';
      else if (button.dataset.filter) this.selection = button.dataset.value;
      this.apply();
    }, { signal: this.controller.signal });
    this.observer = new MutationObserver(() => this.apply());
    this.observer.observe(this.gridContainer, { childList: true, subtree: true });
    this.apply();
  }
  apply() {
    const items = [...this.gridContainer.querySelectorAll('#product-grid > li[data-ret-hose]')];
    let shown = 0;
    items.forEach(item => {
      const matches = !this.selection || item.dataset.retHose === this.selection;
      item.hidden = !matches;
      if (matches) shown++;
    });
    this.querySelectorAll('button[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(this.selection === button.dataset.value)));
    this.querySelector('[data-result]').textContent = shown + (shown === 1 ? ' product' : ' products');
    this.querySelector('[data-reset]').hidden = !this.selection;
    this.querySelector('[data-empty]').hidden = shown > 0 || items.length === 0;
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.controller = null; }
}
if (!customElements.get('retrona-urinal-filters')) customElements.define('retrona-urinal-filters', RetronaUrinalFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retrona-home-categories"] && !Shopify.designMode) return;
  try {
    
class RetronaCategoryCarousel extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    const track = this.querySelector('.rc__grid');
    const previous = this.querySelector('.rc__previous');
    const next = this.querySelector('.rc__next');
    if (!track || !previous || !next) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const update = () => {
      const mobile = matchMedia('(max-width: 749px)').matches;
      track.tabIndex = mobile ? -1 : 0;
      track.setAttribute('aria-label', mobile ? 'Care categories' : 'Care categories. Swipe, drag or use the arrow buttons to browse.');
      const end = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= end - 2;
      this.querySelector('.rc__controls').hidden = end <= 2;
    };
    const move = direction => {
      const card = track.querySelector('.rc__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1), {signal});
    next.addEventListener('click', () => move(1), {signal});
    track.addEventListener('scroll', update, {passive: true, signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || matchMedia('(max-width: 749px)').matches) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault(); track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'instant'});
      }
    }, {signal});
    let startX = 0, startScroll = 0, pointer = null, dragged = false, suppressClick = false;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || matchMedia('(max-width: 749px)').matches) return;
      startX = event.clientX; startScroll = track.scrollLeft; pointer = event.pointerId; dragged = false; suppressClick = false;
    }, {signal});
    track.addEventListener('pointermove', event => {
      if (pointer !== event.pointerId || event.buttons !== 1) return;
      const delta = event.clientX - startX;
      if (!dragged && Math.abs(delta) < 6) return;
      if (!dragged) { dragged = true; track.setPointerCapture(pointer); track.classList.add('is-dragging'); }
      event.preventDefault(); track.scrollLeft = startScroll - delta;
    }, {signal});
    const finish = event => {
      if (event.pointerId !== pointer) return;
      suppressClick = dragged;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(pointer)) track.releasePointerCapture(pointer);
      pointer = null; dragged = false; update();
    };
    track.addEventListener('pointerup', finish, {signal});
    track.addEventListener('pointercancel', finish, {signal});
    track.addEventListener('dragstart', event => event.preventDefault(), {signal});
    track.addEventListener('click', event => { if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; } }, {capture:true, signal});
    this.observer = new ResizeObserver(update);
    this.observer.observe(track);
    update();
  }
  disconnectedCallback() {
    this.controller?.abort(); this.controller = null; this.observer?.disconnect();
  }
}
if (!customElements.get('retrona-category-carousel')) customElements.define('retrona-category-carousel', RetronaCategoryCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retrona-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('retrona-review-cards')) {
  customElements.define('retrona-review-cards', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      this.track = this.querySelector('.rr-reviews__track');
      this.cards = Array.from(this.querySelectorAll('.rr-reviews__card'));
      if (!this.track || !this.cards.length) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || Boolean(window.Shopify?.designMode);
      this.hovered = false;
      this.visible = false;
      this.index = 0;
      this.querySelector('.rr-reviews__controls')?.removeAttribute('hidden');
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-pause')) {
          this.paused = !this.paused;
          this.syncPause();
          this.arm();
        } else if (button.hasAttribute('data-direction')) {
          this.pause();
          this.go(this.index + Number(button.dataset.direction), true);
        }
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; clearTimeout(this.timer); }
      }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') { this.hovered = false; this.arm(); }
      }, options);
      this.addEventListener('focusin', event => { if (!event.target.closest('[data-pause]')) this.pause(); }, options);
      this.track.addEventListener('pointerdown', () => this.pause(), options);
      this.track.addEventListener('wheel', event => { if (Math.abs(event.deltaX) > 0) this.pause(); }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
        const keys = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.lastIndex };
        if (!(event.key in keys)) return;
        event.preventDefault();
        this.pause();
        this.go(keys[event.key], true);
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.update(), 80);
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const i = this.cards.indexOf(event.target.closest('.rr-reviews__card'));
        if (i >= 0) { this.pause(); this.go(i, true); }
      }, options);
      document.addEventListener('visibilitychange', () => this.arm(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
      this.resize = new ResizeObserver(() => {
        this.measure();
        this.track.scrollTo({ left: this.cards[Math.min(this.index, this.lastIndex)].offsetLeft, behavior: 'instant' });
        this.update();
      });
      this.resize.observe(this.track);
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.arm();
      }, { threshold: 0.2 });
      this.intersection.observe(this.track);
      this.measure();
      this.update();
      this.syncPause();
    }
    measure() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.perView = Math.max(1, Math.round((this.track.clientWidth + gap) / (this.cards[0].offsetWidth + gap)));
      this.lastIndex = Math.max(0, this.cards.length - this.perView);
    }
    go(index, announce = false) {
      index = Math.max(0, Math.min(index, this.lastIndex));
      this.track.scrollTo({ left: this.cards[index].offsetLeft, behavior: this.motion.matches ? 'instant' : 'smooth' });
      if (announce) this.querySelector('.rr-reviews__status').textContent = 'Reviews ' + (index + 1) + ' to ' + Math.min(index + this.perView, this.cards.length) + ' of ' + this.cards.length;
    }
    update() {
      this.index = this.cards.reduce((closest, card, i) => Math.abs(card.offsetLeft - this.track.scrollLeft) < Math.abs(this.cards[closest].offsetLeft - this.track.scrollLeft) ? i : closest, 0);
      this.index = Math.min(this.index, this.lastIndex);
      const end = Math.min(this.index + this.perView, this.cards.length);
      const range = this.perView > 1 ? (this.index + 1) + '–' + end : String(this.index + 1);
      const count = this.querySelector('.rr-reviews__count');
      if (count) count.textContent = range + ' / ' + this.cards.length;
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      if (previous) previous.disabled = this.index === 0;
      if (next) next.disabled = this.index === this.lastIndex;
    }
    pause() { this.paused = true; clearTimeout(this.timer); this.syncPause(); }
    syncPause() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      button.textContent = this.paused ? 'Play' : 'Pause';
      button.setAttribute('aria-label', this.paused ? 'Play automatic reviews' : 'Pause automatic reviews');
    }
    arm() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || !this.visible || document.hidden || !this.lastIndex) return;
      this.timer = setTimeout(() => { this.go(this.index >= this.lastIndex ? 0 : this.index + 1); this.arm(); }, 5000);
    }
    disconnectedCallback() {
      this.cleanup?.abort(); this.resize?.disconnect(); this.intersection?.disconnect();
      clearTimeout(this.timer); clearTimeout(this.scrollTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
